import React, { useRef, useState } from 'react'

import { DialogProps as IDefaultDialogProps } from '@material-ui/core/Dialog'

export interface DialogProps {
  title: string
  message?: string
  content?: React.ReactChild
  onClose?: () => void
}

export interface TriggerDialogProps<T> {
  dialog: any
  dialogProps?: Partial<DialogProps> & Partial<IDefaultDialogProps> & T
  children?: React.ReactChildren | React.ReactChild
  onClick?: (e?: any) => void
  mounted?: boolean
  disabled?: boolean
}

const TriggerDialog = <T,>({
  children,
  dialog: Dialog,
  dialogProps: { open, onClose, ...restDialogProps },
  onClick,
  disabled
}: TriggerDialogProps<T>) => {
  const mounted = useRef(false)
  const [isOpen, setOpen] = useState(open || false)
  const elements = React.Children.toArray(children)
  const trigger = React.Children.count(elements) === 1

  const handleClose = (): void => {
    setOpen(false)

    if (onClose) {
      onClose()
    }
  }

  const handleClick = (e) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    if (onClick) onClick(e)
    mounted.current = true

    setOpen(true)
  }

  return (
    <>
      {trigger &&
        React.cloneElement(
          elements[0] as any,
          !disabled && { onClick: handleClick }
        )}
      {mounted.current && !disabled && (
        <Dialog {...restDialogProps} open={isOpen} onClose={handleClose} />
      )}
    </>
  )
}

export default TriggerDialog
